import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 76px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 76px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 30px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 4px;\n  opacity: 0.6;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  white-space: nowrap;\n  margin: 0 0 0 auto;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: #fff;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  height: 70px;\n  justify-content: space-between;\n  left: 0;\n  position: absolute;\n  top: 70px;\n  width: 100%;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import BackArrowPath from '../assets/icons/back-arrow-white.svg';
import BackArrowSlatePath from '../assets/icons/arrow-left.svg';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject());
var Title = styled.div(_templateObject2(), function (props) {
  return props.verticalSubText && "\n      flex-direction: column;\n    ";
});
var Subtext = styled.span(_templateObject3());
var Back = styled.img(_templateObject4());
var BackContainer = styled.div(_templateObject5());
var TitleContainer = styled.div(_templateObject6());
var ChildrenContainer = styled.div(_templateObject7());

var InvertedStrip = function InvertedStrip(props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className
  }, /*#__PURE__*/React.createElement(BackContainer, null, props.showBack && /*#__PURE__*/React.createElement(Back, {
    onClick: props.onBackPress,
    src: props.hasDarkBackArrow ? BackArrowSlatePath : BackArrowPath,
    alt: "Back."
  })), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, null, props.title && /*#__PURE__*/React.createElement("span", null, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtext, null, props.subtext))), /*#__PURE__*/React.createElement(ChildrenContainer, null, props.children));
};

export { InvertedStrip };